import "./App.css";
import Routes from "@/routes/index";

function App() {
  return <Routes />;
}

export default App;
